import React from 'react'

import { Modal } from '../ui_new'
import { WarningAmber } from '@mui/icons-material'

const SharedDocumentErrorModal = ({ type, title, message }) => {
  const titleLabel = title ?? (type === 'expired' ? 'Partage expiré' : 'Lien invalide')
  const messageLabel = message ?? (type === 'expired' 
    ? "Ce lien de partage n'est plus accessible, le délai autorisé a été dépassé.\nSi vous avez besoin d'y accéder de nouveau, veuillez contacter l'expéditeur."
    : "Le lien de partage que vous avez utilisé est invalide. Veuillez vérifier le lien ou contacter l'expéditeur pour obtenir un nouveau lien de partage.")
  return (
    <Modal className="modal-v2 modal-v2--mid modal-v2--z-index-top modal-v2--blur">
      <div className='modal-v2__heading'>
        <div>
          <h2>{titleLabel}</h2>
        </div>
      </div>
      <div className='modal-v2__body pb-4'>
        <div className="share-warning--error-block flex flex-row gap-2">
          <WarningAmber fontSize='small' />
          <p>
            {messageLabel}
          </p>
        </div>
      </div>
    </Modal>
  )
}

export default SharedDocumentErrorModal
